import { type Editor } from '@tiptap/react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useViewport } from '@/hooks';
import { TextQuoteIcon } from '@/icons';
import { Tooltip } from '@/ui_v3';
import { IconButton } from '@/ui_v3/components/button';
import { cn } from '@/utils/tailwind.util';
import { useBlockquote } from './useBlockquote';
export const BlockquoteButton = ({
  editor
}: {
  editor: Editor | null;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const {
    handleToggle,
    isActive
  } = useBlockquote({
    editor
  });
  const {
    isMobile
  } = useViewport();
  return <Tooltip.Provider disableHoverableContent={isMobile} data-sentry-element="unknown" data-sentry-component="BlockquoteButton" data-sentry-source-file="BlockquoteButton.tsx">
      <Tooltip.Root data-sentry-element="unknown" data-sentry-source-file="BlockquoteButton.tsx">
        <Tooltip.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="BlockquoteButton.tsx">
          <IconButton className={cn(isActive && 'bg-gray-200')} variant="transparent" intent="neutral" size="xs" onMouseDown={e => {
          e.preventDefault(); // Prevent focus loss
        }} onClick={() => {
          handleToggle();
          logger.track('build_addblockquote');
        }} data-sentry-element="IconButton" data-sentry-source-file="BlockquoteButton.tsx">
            <TextQuoteIcon size="xs" fill={isActive ? ICON_COLOR.strong : ICON_COLOR.default} data-sentry-element="TextQuoteIcon" data-sentry-source-file="BlockquoteButton.tsx" />
          </IconButton>
        </Tooltip.Trigger>
        <Tooltip.Content data-sentry-element="unknown" data-sentry-source-file="BlockquoteButton.tsx">{t('build.textEditor.blockquote')}</Tooltip.Content>
      </Tooltip.Root>
    </Tooltip.Provider>;
};